import * as React from "react";
const SvgIndentedNatural = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 128 128", contentScriptType: "text/ecmascript", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m18 103 47-72 48 53", style: {
  stroke: "#390",
  fill: "none",
  strokeWidth: 3
} }), /* @__PURE__ */ React.createElement("path", { d: "m12 97 52-79 55 60", style: {
  fill: "none",
  stroke: "#f03",
  strokeWidth: 3
} }));
export default SvgIndentedNatural;
